<script>
    // Linked from the footer since the UX patches shipped, and until now it
    // rendered the landing page.
    export let updated = '9 October 2026';
</script>

<div class="u-page">
    <article class="u-prose">
        <p class="eyebrow">Legal</p>
        <h1>Terms of Use</h1>
        <p class="updated">Last updated {updated}</p>

        <h2>What SkinGenie is</h2>
        <p>
            SkinGenie reads a photo of your face, scores a set of skin characteristics,
            and suggests skincare products and an order to use them in. It is a
            consumer product built on published ingredient data and retailer listings.
        </p>

        <h2>What it is not</h2>
        <p>
            SkinGenie is not a medical device and does not provide medical advice. It
            cannot diagnose a skin condition, and nothing it tells you is a substitute
            for a dermatologist, a doctor, or a pharmacist. If something on your skin
            is changing, painful, bleeding, or not getting better, see a clinician.
        </p>
        <p>
            If you are pregnant or breastfeeding, or using prescription treatments,
            check with your clinician before starting anything SkinGenie suggests.
            Some common skincare actives are not advised during pregnancy.
        </p>

        <h2>Product information</h2>
        <p>
            Prices, availability, ingredient lists and ratings come from retailer
            listings and are only as current as the last time we read them. They can
            be wrong or out of date. Check the label and the retailer before you buy
            or apply anything, particularly if you react to an ingredient.
        </p>
        <p>
            Where SkinGenie says it is avoiding an ingredient for you, it matches
            against the published ingredient lists it holds. It cannot screen a
            product whose ingredients it does not have, and it cannot reliably screen
            for fragrance. That limitation is stated where you choose sensitivities,
            and it is a real one.
        </p>

        <h2>Your account</h2>
        <p>
            Sign-in is handled by Auth0. Keep your sign-in details to yourself; you
            are responsible for what happens under your account. You can stop using
            SkinGenie at any time, and you can ask us to delete your data: see the
            <a href="/privacy">privacy policy</a>.
        </p>

        <h2>Acceptable use</h2>
        <p>
            Upload photos of yourself, or of someone who has asked you to. Do not
            upload photographs of other people without their knowledge, and do not
            upload photographs of children. Do not try to scrape, overload or break
            the service.
        </p>

        <h2>Liability</h2>
        <p>
            SkinGenie is provided as it is, without warranty. We are not liable for
            any reaction, loss or damage arising from a product you chose to buy or
            apply. Deciding what to put on your skin remains yours.
        </p>

        <h2>Changes</h2>
        <p>
            These terms may change as the product does. The date at the top says when
            they last did.
        </p>

        <h2>Contact</h2>
        <p>
            <a href="mailto:privacy@skingenie.ai">privacy@skingenie.ai</a>
        </p>
    </article>
</div>

<style>
    .eyebrow {
        font-size: var(--text-xs);
        letter-spacing: var(--track-wide);
        text-transform: uppercase;
        color: var(--text-muted);
        margin-bottom: var(--space-2);
    }

    .updated {
        color: var(--text-muted);
        font-size: var(--text-sm);
        margin-top: calc(var(--space-2) * -1);
    }

    h2 {
        margin-top: var(--space-10);
    }
</style>
